import { render, staticRenderFns } from "./TutorialModal.vue?vue&type=template&id=3a8a8d0f&scoped=true&"
import script from "./TutorialModal.vue?vue&type=script&lang=js&"
export * from "./TutorialModal.vue?vue&type=script&lang=js&"
import style0 from "./TutorialModal.vue?vue&type=style&index=0&id=3a8a8d0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8a8d0f",
  null
  
)

export default component.exports